import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Gps_Inst } from './gps_inst';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';

export class GPS {
    gps_Inst: Gps_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.gps_Inst = new Gps_Inst();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind = CommonEnums.defaults.CHANGE_IND_NO;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
    }

    static parse(gPSTmp: GPS): GPS {
        let gPS: GPS = new GPS();
        gPS.copyFrom(gPSTmp);
        return gPS;
    }

    copy(): GPS {
        let gpsTmp: GPS = new GPS();

        gpsTmp.gps_Inst = this.gps_Inst.copy();
        gpsTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        gpsTmp.change_Ind = this.change_Ind;
        gpsTmp.error_Cd = this.error_Cd;
        gpsTmp.error_Msg = this.error_Msg;
        gpsTmp.ref_Id = this.ref_Id;
        gpsTmp.ref_Cd = this.ref_Cd;
        gpsTmp.fldr_Id = this.fldr_Id;
        gpsTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);

        return gpsTmp;
    }

    copyFrom(gpsTmp: GPS): void {
        this.gps_Inst.copyFrom(gpsTmp.gps_Inst);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, gpsTmp.dxFlow_Obj_Properties);
        this.change_Ind = gpsTmp.change_Ind;
        this.error_Cd = gpsTmp.error_Cd;
        this.error_Msg = gpsTmp.error_Msg;
        this.ref_Id = gpsTmp.ref_Id;
        this.ref_Cd = gpsTmp.ref_Cd;
        this.fldr_Id = gpsTmp.fldr_Id;
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, gpsTmp.conn_Db_Obj_Lnks);
    }

    compare(gpsTmp: GPS): string {
        let diffString = '';
        diffString = this.gps_Inst.compare(gpsTmp.gps_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, gpsTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;
        
        return diffString;
    }

    tostring(): string {
        return "GPS [gps_Inst=" + this.gps_Inst +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id + "]"
    }
}